// extracted by mini-css-extract-plugin
export default {"container":"Bea-z","innerContainer":"Cea-z","multipleLines":"Dea-z","heading":"Eea-z","content":"Fea-z","linkColor":"Gea-z"};